import React, { useState, useCallback, useEffect } from 'react';
import { useThrottleFn } from 'ahooks';
import { Tooltip } from '@mantine/core';
import { NumberInputGroup } from '@shakkerai/pro-components';

export const Number = React.memo((props) => {
  const { title, tooltip, name, step, min, max, value, onChange } = props;
  const [innerValue, setInnerValue] = useState(value);
  const onChangeThrottled = useThrottleFn(onChange, { wait: 300 });

  const handleChange = useCallback(
    (value, name) => {
      setInnerValue(() => value);
      onChangeThrottled.run(value, name);
    },
    [onChangeThrottled],
  );

  useEffect(() => {
    setInnerValue(value);
  }, [value]);

  return (
    <div className="flex items-center">
      <Tooltip
        disabled={!tooltip}
        maw={300}
        multiline
        position="left-start"
        label={<span className="text-xs leading-[14px]">{tooltip}</span>}
      >
        <span className="w-[120px] mr-3 text-xs text-[#7f7f7f]">{title}</span>
      </Tooltip>
      <NumberInputGroup
        min={min}
        max={max}
        step={step}
        name={name}
        inputWidth={42}
        value={innerValue}
        onChange={handleChange}
      />
    </div>
  );
});

export const NumberView = React.memo(({ title, value }) => {
  return (
    <>
      <div className="p-4 flex justify-between items-center">
        <h5 id="model-checkpoints-entry" className="text-[#2d2d2d] text-xs  leading-[14px] font-bold font-gro">
          {title}
        </h5>
        <span className="block text-[#2d2d2d] text-xs font-normal">{value}</span>
      </div>
      <div className="border-t border-[#efefef]" />
    </>
  );
});
